import { toast } from '@livable/saas-react-components';
import { Button, FormControl, FormHelperText, InputAdornment, OutlinedInput, TextField, Typography, Alert, InputLabel } from '@mui/material';
import { useFormik } from 'formik';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import { refundInitialValues, refundSchema } from 'src/utils/formValidation/Transaction';
import useStyles from '../styles';
export const RefundForm = observer(_ref => {
  let triggerRefresh = _ref.triggerRefresh,
    setTriggerRefresh = _ref.setTriggerRefresh;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const postRefund = async data => {
    const resp = await store.transaction.applyRefundAsync.run(data);
    return resp;
  };
  const formik = useFormik({
    initialValues: refundInitialValues,
    validateOnMount: true,
    onSubmit: async values => {
      toast('loading', {
        body: ['Applying refund...']
      }); // ? i18n

      const data = {
        amount: values.amount,
        notes: values.notes,
        transactionId: store.transaction.transactionId
      };
      postRefund(data).then(() => {
        toast('success', {
          body: ['The refund was successfully applied']
        });
        store.transaction.setRefundModalIsOpen(false);
      }).then(() => {
        store.transaction.setUpdateData();
      }).finally(() => {
        setTriggerRefresh(!triggerRefresh);
      });
    },
    validationSchema: refundSchema(store.transaction.availableRefundAmount)
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Alert, {
    severity: "info",
    icon: false,
    size: "small"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('resident_account.refund_information')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('resident_account.available_refund_amount', {
    amount: "$".concat(Number(store.transaction.availableRefundAmount).toFixed(2))
  }))), /*#__PURE__*/React.createElement("form", {
    id: "refund",
    onSubmit: formik.handleSubmit
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.formFields
  }, /*#__PURE__*/React.createElement(FormControl, {
    className: classes.smallField,
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "amount"
  }, t('resident_account.enter_amount')), /*#__PURE__*/React.createElement(OutlinedInput, {
    id: "amount",
    onKeyPress: event => {
      if (!/[0-9]|[.,]/.test(event.key)) {
        event.preventDefault();
      }
    },
    onChange: e => {
      if (!/^\d+([.,]\d{0,2})?$|^$/.test(e.target.value)) return;
      formik.handleChange(e);
    },
    value: formik.values.amount,
    label: t('resident_account.enter_amount'),
    placeholder: "0.00",
    startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "start"
    }, "$"),
    type: "number",
    error: formik.touched.amount && Boolean(formik.errors.amount)
  })), /*#__PURE__*/React.createElement(FormHelperText, null, formik.errors.amount), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    id: "notes",
    name: "notes",
    label: t('resident_account.notes'),
    onChange: e => {
      if (e.target.value.length <= 255) formik.handleChange(e);
    },
    type: "text",
    value: formik.values.notes,
    variant: "outlined",
    multiline: true,
    maxRows: 10,
    rows: 4
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.counter
  }, "(", formik.values.notes.length, "/255)"))), /*#__PURE__*/React.createElement("div", {
    className: classes.modalFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => store.transaction.setRefundModalIsOpen(false),
    'custom-attribute': '460-refund-modal'
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: !formik.isValid || formik.values.amount <= 0 || formik.values.amount > store.transaction.availableRefundAmount || store.transaction.applyRefundAsync.inProgress,
    form: "refund",
    type: "submit",
    variant: "contained",
    'custom-attribute': '461-refund-modal'
  }, t('resident_account.process_refund'))))))));
});